module.exports = __webpack_public_path__ + "img/14-ton-refrigerated-truck.a64bb5a1.jpg";